import { defaultTo } from 'aa_common/front-end/helpers'
import { useFormikContext } from 'formik'
import { useEffect, useMemo } from 'react'

import { FORM_FIELDS } from '../const'
import { useFormReady } from './use-form-ready'

export const useBookValueReference = (acquisitionCostReference?: number, netAcquisitionCost?: number) => {
  const { setFieldValue } = useFormikContext()
  const isFormReady = useFormReady()

  const bookValueReference = useMemo(() => {
    return defaultTo(netAcquisitionCost, acquisitionCostReference)
  }, [acquisitionCostReference, netAcquisitionCost])

  useEffect(() => {
    isFormReady && setFieldValue(FORM_FIELDS.BOOK_VALUE_REFERENCE, bookValueReference)
  }, [bookValueReference, isFormReady])

  return bookValueReference
}
